import { CatalogProductFooter } from '@widgets/footer';

import { usePolicyResponsibilityService } from '../services/usePolicyResponsibilityService';

export const PolicyResponsibilityContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { displayPolicyResponsibility, isHide } = usePolicyResponsibilityService();

  if (isHide) {
    return null;
  }

  return <CatalogProductFooter show_policy_responsibility={displayPolicyResponsibility} />;
};
